module.exports = __webpack_public_path__ + "app-static/img/ok-banner1.71a93e59.png";